// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"238":"bceb7d25","239":"af2d9657","424":"e662cad4","455":"df46f1f5","577":"9527880c","977":"2860850f"}[chunkId] + ".chunk.js";
};